import React, { useState, useEffect } from 'react';
import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import Avvvatars from "avvvatars-react";
import Modal from "../layout/Modal";
import { useForm } from "react-hook-form";
import useAPI from "../../hooks/useAPI";
import { FaAngleLeft, FaSortDown, FaSortUp, FaHeadphones, FaSpinner, FaBusinessTime } from "react-icons/fa";
import { RiMoneyDollarCircleLine } from "react-icons/ri";
import { FaHeartPulse, FaTags } from "react-icons/fa6";
import { IoClose } from "react-icons/io5";
import { BsSearch, BsPencilFill, BsPersonFillSlash } from "react-icons/bs";
import { CgMenuRight } from "react-icons/cg";
import { BiSolidLabel } from "react-icons/bi";
import { PiUserSwitchFill } from "react-icons/pi";
import {sendToast} from '../plugins/toastAll';
import { PiSpinner } from "react-icons/pi";
import { Tooltip } from 'react-tooltip';
import { DotLottieReact } from '@lottiefiles/dotlottie-react';
import { color, height } from '@mui/system';

const MessagesContentHeader = ({
  showContactInfo,
  classInfo,
  idChatSelected,
  nameInitials,
  contactName,
  isAssignedAgent,
  statusChat,
  isSavedChat,
  listStatus,
  listAreas,
  listTags,
  tableListTags,
  searchArea,
  validationModalTags,
  feeling,
  isFeeling,
  interestedBuying,
  isInterestedBuying,
  permissions,
  token,
  setLoading,
  setClassChat,
  setShowContactInfo,
  setClassInfo,
  setNotChatSelected,
  setIsChatSelected,
  setModalTransferAgent,
  setListAreas,
  setListTags,
  setValidationModalTags,
  onChatSelected,
  onChatStatus,
  getIsDark,
  getTagContact,
  updateConversations,
  showTooltip,
  statusContact
}) => {

  const [showTransfer, setShowTransfer] = useState(false);
  const [modalTransferArea, setModalTransferArea] = useState(false);
  const [searchModalArea, setSearchModalArea] = useState("");
  const [showStatus, setShowStatus] = useState(false);
  const [modalTags, setModalTags] = useState(false);
  const [showOptionsChat, setShowOptionsChat] = useState(false);
  const [searchTags, setSearchTags] = useState("");

  const { urlAPI, urlAPI_1, urlAPI_2, fetchWithAuth } = useAPI();

  const navigate = useNavigate();

  const {watch,register,handleSubmit,formState: { errors },reset} = useForm();

  ///#--> Funcion que envia el area que se asigno al chat
  const onAsingArea = async (id) => {
    var objFinal = {
      areaId: id,
      chatId: localStorage.getItem("CONVERSATION_SELECTED")
    };
    console.log('-------objSend----->', objFinal)
    try {
      setLoading(true);
      const url = urlAPI_1 + "assignChat/" + localStorage.getItem("CHAT_SELECTED");;
      const options = { method: "POST", mode: "cors", body: JSON.stringify(objFinal)};
      const response = await fetchWithAuth(url, options);
      const result = await response.json();
      setModalTransferArea(false);
      sendToast(result)
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    };
  };
  
  ///#--> Buscador para las áreas
  const onSearchArea = (value) => {
    var searchResults = searchArea.filter((element) => {
      if (element.description.toString().toLowerCase().includes(value.toLowerCase())) {
        return element;
      }
    });
    setListAreas(searchResults);
  };

  //#--> Etiquetar contacto
  const putTagContact = async () => {
    const {tags} = watch()
    const body = tags.toString();
    console.log('Etiquetas seleccionadas==>', body);
    const chatSelected = localStorage.getItem("CHAT_SELECTED");
    const idContact = localStorage.getItem("PHONE_CHAT_SELECTED") || chatSelected || idChatSelected;
    if (!idContact) return;
    try {
      setLoading(true);
      const values = {
        tags: body
      };
      const url = urlAPI_1 + `tagsContact/${encodeURIComponent(idContact)}`;
      const options = { method: "PUT", mode: "cors", body: JSON.stringify(values)};
      const response = await fetchWithAuth(url, options);
      const result = await response.json();
      console.log("Data Send", result);
      setModalTags(false);
      await getTagContact(chatSelected);
      sendToast(result)
      console.log("Calling getConversations from putTagContact");
      updateConversations();
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    };
  }
    
  //#--> Buscador en la lista de tags
  const searchTagsChecked = (searchTerm) => {
    var searchResults = tableListTags.filter((element) => {
      if (element.title.toString().toLowerCase().includes(searchTerm.toLowerCase())) {
        return element;
      }
    });
    setListTags(searchResults);
    if (searchResults.length === 0) {
      setValidationModalTags(true);
    } else {
      setValidationModalTags(false);
    }
  };

  useEffect(() => {
    console.log('-----------------useEffect actualizar lista de tags-------------------');
    const defaultValues = listTags.sort((a, b) => (a.tagActive === b.tagActive) ? 0 : a.tagActive ? -1 : 1)
    reset(defaultValues); 
  }, [listTags]);

  const agentAssign = localStorage.getItem("AGENT_ASIGN");
  const isValidAgent = agentAssign && !["bot", "chatbot"].includes(agentAssign);

  return (
    <>
      <header className="message d-flex justify-content-between" style={{height: "7%"}}>
        <div className="back-list">
          <FaAngleLeft className="pointer" style={{ fontSize: "25px" }} onClick={() => setClassChat(false)}/>
        </div>
        <div className="message d-flex" style={{ alignItems: "center", justifyContent: "space-between" }}>
          <div className="cursor-pointer d-flex align-items-center"
            onClick={() => {
              !showContactInfo ? setShowContactInfo(true) : setShowContactInfo(false);
              !classInfo ? setClassInfo(true) : setClassInfo(false);
              getIsDark()
            }}
          >
            <div id='content-avatar-contact' className="logo-wsp">
              <IconList 
                className="cont-avatar" 
                style={{
                  border: statusContact ?`3px solid ${statusChat === "1" ? "#00a884" : statusChat === "2" ? "#f56f89" : "#a7ada7"}` : "",
                  width: "49px",
                  height: "49px",
                  position: "relative"
                }}
              >
                {/* <Avvvatars value={nameInitials} /> */}
                {statusContact ? (
                  <Avvvatars value={nameInitials} />
                ) : (
                  <div className="" style={{width: "100%", height: "100%", background: "#ff5252"}}>
                    <BsPersonFillSlash style={{width: "100%", height: "100%", color:"#FFFFFF", padding: "7px"}}/>
                  </div>
                )}
                
                {!isFeeling && feeling && feeling.length > 0 && permissions.includes("feelings") && (
                  <p 
                    style={{
                      position: "absolute",
                      left: "-10px",
                      top: "-8px",
                      fontSize: "1.3rem",
                      margin: "0"
                    }}
                  >
                    {feeling[0]}
                  </p>
                )}
              </IconList>
            </div>
            <div id="customer-name" className="ml-2 d-flex flex-column align-items-start" style={{lineHeight: "normal"}}>
              <div className="d-flex align-items-center" data-tooltip-id={showTooltip ? "my-tooltip" : undefined} data-tooltip-content={showTooltip ? (`${showContactInfo ? "Ocultar" : "Ver" } info. del contacto`) : undefined}>
                <h1 className='mr-2'>
                  {contactName}
                </h1>
                <BsPencilFill style={{ fontSize: "16px" }}/>
              </div>
              <div className="d-flex align-items-center">
                <FaHeadphones className="mr-1" style={{fontSize: "16px"}} />
                <p className="mb-0" style={localStorage.getItem("AGENT_ASIGN") ? { color: "rgb(91, 192, 222)" } : { color: "rgb(251 0 0)" }}>
                  {localStorage.getItem("AGENT_ASIGN") ? localStorage.getItem("AGENT_ASIGN") : "Sin asignar"}
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* contenedor del estado de animo del contacto */}
          {isValidAgent && permissions.includes("feelings") && (
            <div className="text-center" style={{ width: isFeeling ? "7%" : "auto" }}>
              <>
                {isFeeling ? (
                  <DotLottieReact
                    // src="https://lottie.host/c423a4b9-b179-4847-b14b-8de073d22469/RBfG05eENh.lottie"
                    src="https://lottie.host/7758ece5-810c-4715-82bc-43ab3c7083c3/xjeKz8jnp6.lottie"
                    loop
                    autoplay
                    className="lottie-animation pt-1"
                  />
                ) : (
                  feeling && feeling.length > 1 ? (
                    <label className="feeling m-0 px-1 d-flex align-items-center" style={{ fontSize: "1.3rem" }}>
                      <FaHeartPulse className='mr-1'/>
                      <span>
                        {feeling[1]?.split(" ")[0] || ''}
                      </span>
                      <span className='d-none d-sm-block'>
                        {feeling[1]?.split(" ")[1] || ''}
                      </span>
                    </label>
                  ) : null
                )}
              </>
            </div>
          )}

          {/* contenedor del interés de compra del cliente */}
          {isValidAgent && permissions.includes("interestedBuying") && (
            <div className="text-center px-1" style={{ width: isInterestedBuying ? "8%" : "auto" }}>
            {/* <div className="text-center px-1" style={{ width: "9%" }}> */}
              <>
                {isInterestedBuying ? (
                  <DotLottieReact
                    src="https://lottie.host/d38e206c-5a55-41e3-b0a3-205f906100bf/bU9RgqMEaV.lottie"
                    loop
                    autoplay
                    className="lottie-animation pt-1"
                  />
                ) : (
                  interestedBuying && interestedBuying.percentage ? (
                    <div id='div-content-buying' className="d-flex align-items-center">
                      <label 
                        className="feeling m-0 px-1 d-flex align-items-center" 
                        style={{ 
                          fontSize: "1.3rem"
                        }}
                      >
                        <RiMoneyDollarCircleLine 
                          id='money-dollar'
                          className='mr-1' 
                          style={{ 
                            color: interestedBuying.percentage >= 0 && interestedBuying.percentage <= 49 ? "#3498db" : interestedBuying.percentage > 49 && interestedBuying.percentage <= 79 ? "#f39c12" : "#e74c3c"
                          }}
                        />
                        <span className='d-none d-sm-block'>
                          {interestedBuying.temperature}
                        </span>
                      </label>
                      <label className='d-flex align-items-center feeling m-0' style={{ fontSize: "1.3rem" }}>
                        {interestedBuying.percentage}%
                      </label>
                    </div>
                  ) : null
                )}
              </>
            </div>
          )}

        <div className="dropdown options-header-chat-responsive mr-2">
          <p className="m-0" onClick={() => setShowOptionsChat(prevShow => !prevShow)} >
            {showOptionsChat ?
              <IoClose className="icon-close-menu pointer mr-1" style={{ fontSize: "1.5rem" }}/> :
              <CgMenuRight className="icon-menu pointer mr-1" style={{ fontSize: "1.5rem" }}/>
            }
          </p>
          {showOptionsChat ? (
              <div className="category-list position-absolute status-list" style={{ width: "10rem", zIndex: "9999", right: "0px", padding: "0.5rem 0" }}>
                <div className={`dropdown mx-2 pointer status-chat ${isAssignedAgent && "active"}`} style={{ alignItems: "center" }} data-tooltip-id={showTooltip ? "my-tooltip" : undefined} data-tooltip-content={showTooltip ? "Cambiar estado" : undefined}>
                  <p
                    onClick={() => {
                      if (!isAssignedAgent) {
                        if (showStatus) {
                          setShowStatus(false)
                        } else {
                          setShowStatus(true)
                          setShowOptionsChat(false)
                        }
                      }
                    }}
                  >
                    <a 
                      href="javascript:;"
                      className={
                        statusChat === "1" || statusChat === "Abierto" ? "green d-flex" 
                        : statusChat === "3" || statusChat === "En espera" ? "gray d-flex" 
                        : "red d-flex"
                      }
                    >
                      {showStatus ? 
                        <FaSortUp className="pointer mr-1" style={{ fontSize: "18px", marginTop: "5px" }}/> :
                        <FaSortDown className="pointer mr-1" style={{ fontSize: "18px", marginBottom: "5px" }}/>
                      }

                      {statusChat == "1" || statusChat == "Abierto" ? "Abierto"
                        : statusChat == "2" || statusChat == "Cerrado" ? "Cerrado"
                        : "En espera"
                      }
                    </a>
                  </p>

                  <div className="message-status">
                    <label className="f-w-900" style={{fontStyle: "italic"}}>
                      Por favor primero asigna la conversación para poder cambiar su estado
                    </label>
                  </div>
                </div>

                <div className={`ml-0 mt-2 content-icon-tags ${!isSavedChat && "active"}`}>
                  <div className="dropdown mx-2 pointer status-chat d-flex align-items-center"
                    onClick={() => {
                      if (isSavedChat) {
                        setModalTags(true)
                        setShowOptionsChat(false);
                      }
                    }}
                  >
                    <FaTags
                      style={{ fontSize: "25px" }}
                      data-tooltip-id={showTooltip ? "my-tooltip" : undefined} data-tooltip-content={showTooltip ? (isSavedChat ? "Etiquetar contacto" : "") : undefined}
                      className={`pointer tags ${isSavedChat && "active"}`}
                    />
                    <label className="m-0 ml-2">Etiquetar</label>
                  </div>

                  <div className="message-tags">
                    <p className="f-w-900" style={{fontStyle: "italic"}}>
                      Por favor guarde el contacto para usar las etiquetas
                    </p>
                  </div>

                </div>

                <div className="transfer-chat mt-2 ml-2 d-flex align-items-center"
                  onClick={() => {
                    setShowTransfer((state) => !state)
                    setShowOptionsChat(false);
                  }}
                >
                  <PiUserSwitchFill
                    className="icon-transfer pointer"
                    style={{ fontSize: "29px", position: "relative" }}
                    data-tooltip-id={showTooltip ? "my-tooltip" : undefined} data-tooltip-content={showTooltip ? "Transferir conversación" : undefined}
                  />
                  <label className="m-0 ml-2">Transferir</label>
                </div>
              </div>
          ) : null}

          {showStatus ? (
            <div className="category-list position-absolute status-list" style={{ width: "135px", zIndex: "999999", right: "0", top: "0" }}>
              <span
                className="position-absolute close-transfer pointer"
                style={{ right: "0.2rem", top: "0", fontSize:"1rem", fontWeight:"bold" }}
                onClick={() => {
                  setShowStatus(false);
                }}
              >x</span>
              {listStatus && listStatus.map((stts, k) => (
                <div key={k} className="item-list">
                  <input
                    type="radio"
                    name={stts.id}
                    id={stts.id}
                    className="form-check-input mt-3"
                    value={stts.id}
                    onChange={(e) => {
                      onChatStatus(e.target.value);
                      setShowStatus(false);
                      if (statusChat) {
                        sendToast({type: "success", message: e.target.value == 2 ? "Conversación cerrada con exito" : "Estado cambiado con exito"})
                        if (e.target.value == 2) {
                          setShowContactInfo(false)
                          setNotChatSelected(true)
                          setIsChatSelected(false);
                          setClassChat(false);
                          localStorage.setItem("CHAT_SELECTED", "");
                        }
                      }
                    }}
                  />
                  <label htmlFor={stts.id} className="form-check d-flex justify-content-between cursor-pointer mb-0" key={stts.id} style={{ padding: "5px 2px 5px 1.25rem" }}>
                    <div>
                      <label htmlFor={stts.id} className="form-check-label pl-0 f-w-400">
                        {stts.Description}
                      </label>
                    </div>
                    <div
                      htmlFor={stts.id}
                      className={`circle-status ${
                        stts.Description == "1" || stts.Description == "Abierto" ? "green"
                        : stts.Description == "2" || stts.Description == "Cerrado" ? "red"
                        : "gray"
                      }`}
                    ></div>
                  </label>
                </div>
              ))}
            </div>
          ) : null}

          {showTransfer ? (
            <div className="category-list position-absolute status-list p-2" style={{ width: "11.5rem", zIndex: "9911", right: "0", top: "0" }}>
              <span
                className="position-absolute close-transfer pointer"
                style={{ right: "0.2rem", top: "0", fontSize:"1rem", fontWeight:"bold" }}
                onClick={() => {
                  setShowTransfer(false)
                }}
              >x</span>
              <ul className="transfer-options">
                <li className="p-1">
                  <label
                    className="pointer"
                    onClick={() => {
                      setModalTransferArea(true);
                      setShowTransfer((state) => !state)
                    }}
                  >
                    Transferir a un área
                  </label>
                </li>
                <li className="p-1">
                  <label
                    className="pointer"
                    onClick={() => {
                      setModalTransferAgent(true);
                      setShowTransfer((state) => !state)
                    }}
                  >
                    Transferir a un agente
                  </label>
                </li>
              </ul>
            </div>
          ) : null}

        </div>

        <div className="options-header-chat d-flex justify-content-end align-items-center">
          <div className={`dropdown mx-2 pointer status-chat ${isAssignedAgent && "active"}`} style={{ alignItems: "center" }} data-tooltip-id={showTooltip ? "my-tooltip" : undefined} data-tooltip-content={showTooltip ? "Cambiar estado" : undefined}>
            <p
              onClick={() => {
                if (!isAssignedAgent) {
                  if (showStatus) {
                    setShowStatus(false)
                  } else {
                    setShowStatus(true)
                  }
                }
              }}
            >
              <a href="javascript:;"
                className={
                  statusChat === "1" || statusChat === "Abierto" ? "green d-flex"
                    : statusChat === "3" || statusChat === "En espera" ? "gray d-flex"
                    : "red d-flex"
                }
              >
                {showStatus ?
                  <FaSortUp className="pointer mr-1" style={{ fontSize: "18px", marginTop: "5px" }}/> :
                  <FaSortDown className="pointer mr-1" style={{ fontSize: "18px", marginBottom: "5px" }}/>
                }

                {statusChat == "1" || statusChat == "Abierto"
                  ? "Abierto"
                  : statusChat == "2" || statusChat == "Cerrado"
                  ? "Cerrado"
                  : "En espera"}
              </a>
            </p>
            {showStatus ? (
              <div className="category-list position-absolute status-list span-color" style={{ width: "135px", zIndex: "9" }}>
                {listStatus && listStatus.map((stts, k) => (
                  <div key={k} className="item-list">
                    <input
                      type="radio"
                      name={stts.id}
                      id={stts.id}
                      className="form-check-input mt-3"
                      value={stts.id}
                      onChange={(e) => {
                        onChatStatus(e.target.value);
                        if (statusChat) {
                          console.log("estado cambiado desde response");
                          sendToast({type: "success", message: e.target.value == 2 ? "Conversación cerrada con exito" : "Estado cambiado con exito"})

                          if (e.target.value == 2) {
                            setNotChatSelected(true)
                            setIsChatSelected(false);
                            setClassChat(false);
                          }
                          setShowStatus(false);
                        }
                      }}
                    />
                    <label htmlFor={stts.id} className="form-check d-flex justify-content-between cursor-pointer mb-0" key={stts.id} style={{ padding: "5px 2px 5px 1.25rem" }}>
                      <div>
                        <label htmlFor={stts.id} className="form-check-label pl-0 f-w-400">
                          {stts.Description}
                        </label>
                      </div>
                      <div
                        htmlFor={stts.id}
                        className={`circle-status ${
                          stts.Description == "1" || stts.Description == "Abierto" ? "green"
                          : stts.Description == "2" || stts.Description == "Cerrado" ? "red"
                          : "gray"
                        }`}
                      ></div>
                    </label>
                  </div>
                ))}
              </div>
            ) : null}

            <div className="message-status">
              <label className="f-w-900" style={{fontStyle: "italic"}}>
                Por favor primero asigna la conversación para poder cambiar su estado
              </label>
            </div>
          </div>

          <div className={`ml-0 mt-2 content-icon-tags ${!isSavedChat && "active"}`}>
            <div className="dropdown mx-2 pointer status-chat" style={{ alignItems: "center"}}>
              <FaTags
                style={{ fontSize: "25px" }}
                data-tooltip-id={showTooltip ? "my-tooltip" : undefined} data-tooltip-content={showTooltip ? (isSavedChat ? "Etiquetar contacto" : "") : undefined}
                className={`pointer tags ${isSavedChat && "active"}`}
                onClick={() => {
                  if (isSavedChat) {
                    setModalTags(true)
                  }
                }}
              />
            </div>

            <div className="message-tags">
              <p className="f-w-900" style={{fontStyle: "italic"}}>
                Por favor guarde el contacto para usar las etiquetas
              </p>
            </div>

          </div>

          <div className="transfer-chat ml-2 d-flex" style={{ alignItems: "center" }}>
            <PiUserSwitchFill
              className="pointer icon-transfer"
              style={{ fontSize: "29px", position: "relative" }}
              data-tooltip-id={showTooltip ? "my-tooltip" : undefined} data-tooltip-content={showTooltip ? "Transferir conversación" : undefined}
              onClick={() => {
                setShowTransfer((state) => !state)
              }}
            />

            {showTransfer ? (
              <div className="category-list position-absolute status-list p-2" style={{ width: "11.5rem", zIndex: "9", right: "1rem", top: "2.3rem" }}>
                <span
                  className="position-absolute close-transfer pointer"
                  style={{ right: "0.5rem", top: "0", fontSize:"1rem", fontWeight:"bold" }}
                  onClick={() => {
                    setShowTransfer(false)
                  }}
                >x</span>
                <ul className="transfer-options">
                  <li className="p-1">
                    <label
                      className="pointer"
                      onClick={() => {
                        setModalTransferArea(true);
                        setShowTransfer((state) => !state)
                      }}
                    >
                      Transferir a un área
                    </label>
                  </li>
                  <li className="p-1">
                    <label
                      className="pointer"
                      onClick={() => {
                        setModalTransferAgent(true);
                        setShowTransfer((state) => !state)
                      }}
                    >
                      Transferir a un agente
                    </label>
                  </li>
                </ul>
              </div>
            ) : null}

          </div>
        </div>
      </header>

      {/* Modal para transferir a un área */}
      <Modal
        status={modalTransferArea}
        changeStatus={setModalTransferArea}
        title="Transferir a un área"
        width={"450px"}
      >
        <Content>
          <div className="w-100">
            <form className="form-inline my-3 justify-content-center">
              <div className="su-control mt-1">
                <input
                  className="form-control"
                  type="text"
                  placeholder="Búsqueda"
                  value={searchModalArea}
                  onChange={(e) => {
                    setSearchModalArea(e.target.value);
                    onSearchArea(e.target.value);
                  }}
                />
              </div>
            </form>
            <div className="list-advisers" style={{overflow: "auto",height: "366px"}}>
              <ul>
                {listAreas.length > 0 ? listAreas.map((area, k) => {
                    const initialWords = area.description.split(" ");
                    const firstWord = initialWords[0];
                    const secondWord = initialWords[1];
                    let icon = "";
                    if (secondWord === undefined) {
                      icon = firstWord[0];
                    } else {
                      icon = firstWord[0] + secondWord;
                    }
                    return (
                      <li key={k} style={{ alignItems: "center" }} className="pointer d-flex align-items-center" onClick={() => {onAsingArea(area._id)}}>
                        <IconList>
                          <Avvvatars value={icon} />
                        </IconList>
                        <div className="d-block">
                          <p className="ml-3 span-color">{area.description}</p>
                        </div>
                      </li>
                    );
                  })
                : <div className="text-center">
                    <h4 className="text-center">No existen areas</h4>
                  </div>
                }
              </ul>

            </div>
          </div>
        </Content>
      </Modal>

      {/* Modal para etiquetar contacto */}
      <Modal
        status={modalTags}
        changeStatus={setModalTags}
        title="Etiquetar contacto"
        width={"480px"}
      >
        <form className="form-inline justify-content-center mb-2 modal-addList">
          <div className="su-control mt-1 d-flex">
            <input
              type="text"
              className="form-control"
              placeholder="Búsqueda"
              value={searchTags}
              onChange={(e) => {
                setSearchTags(e.target.value);
                searchTagsChecked(e.target.value);
              }}
            />
            <button
              className="btn btn-info"
              type="button"
              id="buttonSearchProductBack"
              style={{ height: "34px" }}
            >
              <BsSearch />
            </button>
          </div>
        </form>
        <form className="form-content-modal" onSubmit={handleSubmit(putTagContact)} >
          <ModalContent className="modal-add-users show-list-tags">
            <ul className="o-auto d-flex flex-column justify-content-center align-items-center" style={{ padding: "0 0 5px" }}>
              {listTags.map((tag, t) => {
                return (
                  <li key={t} className="bg-light b-primary m-t-5 p-3 row w-90">
                    <div className="col-8 d-flex align-items-center icon-avatar">
                      <BiSolidLabel
                        style={{
                          color: tag.color,
                          fontSize: "2.5em",
                        }}
                      />
                      <span className="ml-3">{tag.title}</span>
                    </div>
                    <input
                      type="checkbox"
                      value={tag._id}
                      className="cmn-toggle cmn-toggle-round-flat"
                      name={tag._id }
                      id={tag._id}
                      defaultChecked={tag.tagActive}
                      {...register("tags")}
                    />
                    <label className="ml-4" htmlFor={tag._id}></label>
                  </li>
                );
              })}
              {validationModalTags && (
                <div className="text-center mt-3">
                  <div className="empty">
                    <FaTags style={{ fontSize: "55px" }} />
                    <h1 style={{ fontSize: "30px" }}>No tienes etiquetas</h1>
                    <input
                      type="button"
                      className="btn btn-default"
                      value="Ir a crear"
                      onClick={() => {
                        navigate("/home/tags");
                      }}
                    />
                  </div>
                </div>
              )}
            </ul>
          </ModalContent>
          <div className="row justify-content-end mt-3 pt-3">
            <div className="col-sm-6 right">
              <a
                href="javascript:;"
                className="btn btn-lg btn-default mr-1"
                onClick={() => setModalTags((prevMessage) => { return false})}
              >
                Volver
              </a>
              <input
                className="btn btn-lg btn-info"
                value="Aceptar"
                type="submit"
              />
            </div>
          </div>
        </form>
      </Modal>
    </>
  );
};

export default MessagesContentHeader;

const IconList = styled.div`
  margin-bottom: 0px;

  div {
    height: 35px;
    width: 35px;
    border-radius: 50%;
    // box-shadow: 0 2px 7px 0 rgba(0, 0, 0, 0.7);
    margin: 4px auto;
  }

  p {
    font-size: 18px;
    font-weight: 600;
  }
`;
const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  h1 {
    font-size: 42px;
    font-weight: 700;
    margin-bottom: 10px;
    text-align: center;
  }
  li {
    padding: 10px 5px;
    border-bottom: 1px solid rgb(0, 0, 0, 0.05);
  }
  li:hover {
    background: rgb(0, 0, 0, 0.05);
  }
  p {
    font-size: 18px;
    margin-bottom: 0px;
  }
  input {
    padding: 10px;
    border-radius: 0px;
    font-size: 17px;
  }
  img.img-answer {
    cursor: pointer;
    width: auto;
    height: 85px;
    object-fit: scale-down;
  }
  .content-img {
    position: relative;
  }
  .content-img img:hover {
    opacity: 0.6;
  }
`;
const ModalContent = styled.div`
  overflow: auto;
  height: 335px;

  .checkbox {
    padding: 25px;
    width: 25px;
    height: 25px;
  }
`;
